import {
  IncomeModel,
  IncomeType,
  OwnerTypeDTO,
} from '../../../../../../ProfileOPL/Income/api/useIncomeQuery';

const isSpouseSocialSecurity = (income: IncomeModel) =>
  income.IsSpouse || income.OwnerModel?.some(owner => owner.OwnerType === OwnerTypeDTO.Spouse);

export const areBothPartiesCurrentlyReceiving = ({
  incomes,
  hasSpouse,
}: {
  incomes: IncomeModel[] | undefined;
  hasSpouse: boolean;
}): boolean => {
  if (!hasSpouse || incomes == null) {
    return false;
  }

  const socialSecurityIncomes = incomes.filter(
    income => income.IncomeType === IncomeType.SocialSecurity,
  );

  const principalReceiving = socialSecurityIncomes.some(
    income => !isSpouseSocialSecurity(income) && income.CurrentlyReceivingBenefits,
  );
  const spouseReceiving = socialSecurityIncomes.some(
    income => isSpouseSocialSecurity(income) && income.CurrentlyReceivingBenefits,
  );

  return principalReceiving && spouseReceiving;
};
